import { render, staticRenderFns } from "./UserAccesses.vue?vue&type=template&id=2361a63d&"
import script from "./UserAccesses.vue?vue&type=script&lang=js&"
export * from "./UserAccesses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports